import { i18n } from '@lt/localization';

export const formatDistance = (value: number) =>
  value < 1
    ? `${value * 1000} ${i18n.t('commonPages.distanceM')}`
    : `${value} ${i18n.t('hotel.facts.distance_km')}`;
